//================================================================
//  Component: Status Label
//================================================================

//  Purpose: This is a label component displaying the status of a digital request

//  Properties:
//    - status = {A string, this contains the digital request status}
//    - tasktype = {A string, this contains the task type (used to determine if approval or request)}

//  StatusLabel:
//    <StatusLabel
//      status={request?.status}
//      tasktype={request?.tasktype}
//    ></StatusLabel>    

//================================================================

//Libraries
import React from 'react';

//Contexts

//Components

//Functions

//Images

//CSS
import './StatusLabel.css';


export default function StatusLabel({
  status, 
  tasktype
}) { 


  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <div>
      {
        [
          {'name': 'Cancelled', 'background': '#EBEBEB', 'color': '#616161', 'bordercolor': '#616161', 'status': 'Cancelled'}, 
          {'name': 'Not Started', 'background': '#FBF6D9', 'color': '#DC9A03', 'bordercolor': '#DC9A03', 'status': 'Not Started'},
          {'name': 'In Progress', 'background': '#FBF6D9', 'color': '#DC9A03', 'bordercolor': '#DC9A03', 'status': 'In Progress'}, 
          {'name': tasktype?.toLowerCase()?.includes('approval') || tasktype?.toLowerCase()?.includes('review') ? 'Approved' : 'Completed', 'background': '#E7F2DA', 'color': '#237B4B', 'bordercolor': '#237B4B', 'status': 'Completed'},
          {'name': 'Rejected', 'background': '#FCF4F6', 'color': '#C4314B', 'bordercolor': '#C4314B', 'status': 'Rejected'}, 

        ].filter((style) => style.status === status).map((object, index) => (
          <label key={index} style={{backgroundColor: `${object.background}`, color: `${object.color}`, border: `1px solid ${object.bordercolor}`}}  className='Status-Label'>
            {object.name}
          </label>
        ))
      }
    </div>
  )
}
